module.exports = __webpack_public_path__ + "static/media/ruler.2eca9c87.svg";